import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { InMemoryDataService } from './shared/inmemory-db/inmemory-db.service';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from './utils/jwt-interceptor.service';
import { ErrorInterceptor } from './utils/error-interceptor.service';
import { ToastrModule } from 'ngx-toastr';
import { AgmCoreModule } from '@agm/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { StripeModule } from "stripe-angular"
// import { DateDirective } from './service/dateFormat';
import { NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { MomentDateFormatter } from './service/momentFormat';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    SharedModule,
    HttpClientModule,
    BrowserAnimationsModule,
    InMemoryWebApiModule.forRoot(InMemoryDataService, { passThruUnknownUrl: true }),
    AppRoutingModule,
    NgSelectModule,
    NgbModule,
    StripeModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyC2mbxrYXdCBhr53MwtdbeV2Sf28BRd2qk',
      libraries: ['places']
    }),
    ToastrModule.forRoot(),
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }, { provide: NgbDateParserFormatter, useClass: MomentDateFormatter }],
  bootstrap: [AppComponent],
  exports: [NgbModule]
})
export class AppModule { }
